module.exports = __webpack_public_path__ + "static/media/profile-iklil.08c78db7.jpg";